(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const button = document.querySelector('.bf-store-motion');
  const progress = document.querySelector('.bf-store-progress');
  const clock = document.querySelector('[data-bf-clock]');
  let paused = false;
  try { paused = sessionStorage.getItem('bf-motion-paused') === 'true'; } catch {}
  const active = () => !paused && !reduced.matches;
  const animations = new Set();
  function syncMotion() {
    document.body.classList.toggle('motion-paused', !active());
    button.hidden = reduced.matches;
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? 'Pornește animațiile ▷' : 'Oprește animațiile Ⅱ';
    if (!active()) animations.forEach(a => a.finish());
  }
  button.addEventListener('click', () => {paused=!paused;try{sessionStorage.setItem('bf-motion-paused',String(paused))}catch{}syncMotion()});
  reduced.addEventListener('change', syncMotion);syncMotion();
  function tick() {
    const now=Date.now(),start=Date.parse(clock.dataset.start),end=Date.parse(clock.dataset.end);
    if(now>=end){clock.textContent='Campania s-a încheiat';return}
    const seconds=Math.max(0,Math.floor(((now<start?start:end)-now)/1000));
    const days=Math.floor(seconds/86400),hours=Math.floor(seconds%86400/3600),minutes=Math.floor(seconds%3600/60);
    clock.textContent=`${now<start?'Începe în':'Se încheie în'} ${days}z ${String(hours).padStart(2,'0')}h ${String(minutes).padStart(2,'0')}m`;
  }
  tick();const interval=setInterval(()=>{if(!document.hidden)tick()},30000);
  const observed=new WeakSet();
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;observer.unobserve(entry.target);
    if(!active())return;
    const animation=entry.target.animate([{opacity:.55,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:450,easing:'cubic-bezier(.2,.65,.3,1)'});
    animations.add(animation);animation.onfinish=()=>animations.delete(animation);
  }),{threshold:.08});
  function scan(root) {
    root.querySelectorAll('.product-card,.as-product-card,.asb-flavor-card,.as-product-benefits__grid article,.as-pack-option').forEach(el=>{
      if(observed.has(el))return;observed.add(el);observer.observe(el);
      if(el.matches('.product-card,.as-product-card,.asb-flavor-card'))el.classList.add('bf-card-interactive');
    });
  }
  scan(document);
  let refreshFrame=0;
  new MutationObserver(()=>{if(!refreshFrame)refreshFrame=requestAnimationFrame(()=>{refreshFrame=0;scan(document)})}).observe(document.querySelector('#MainContent'),{childList:true,subtree:true});
  let scrollFrame=0;
  function paintProgress(){scrollFrame=0;const total=document.documentElement.scrollHeight-innerHeight;progress.style.transform=`scaleX(${total>0?Math.min(1,Math.max(0,scrollY/total)):0})`}
  addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(paintProgress)},{passive:true});
  addEventListener('resize',paintProgress,{passive:true});paintProgress();
  addEventListener('pagehide',()=>{clearInterval(interval);observer.disconnect()},{once:true});
})();
